import React from 'react';
import CSSModules from 'react-css-modules';

import { getClasses } from '../../services/stylingUtilities';

import style from './style.scss';

class TransparentButton extends React.Component {
    focus() {
        this.button.focus();
    }

    _getClassNames() {
        return getClasses(style, { button: true }, this.props.className);
    }

    render() {
        if (!this.props.show) return null;

        return (
            <button {...this.props} ref={e => (this.button = e)} className={this._getClassNames()}>
                {this.props.children}
            </button>
        );
    }
}

TransparentButton.defaultProps = {
    show: true,
    type: 'button'
};

export default CSSModules(TransparentButton, style);



// WEBPACK FOOTER //
// ./components/TransparentButton/index.js